<p-dialog
  header="Editar Área"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '25%', height: '30vh' }"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <div class="flex flex-column gap-3 mb-3" *ngIf="!isLoading">
    <div class="field">
      <label for="area" class="font-semibold">Área</label>
      <input
        pInputText
        id="area"
        type="text"
        [(ngModel)]="area"
        (ngModelChange)="onChangeInput($event, 'area')"
        [placeholder]="'Ingresa nombre del área'"
      />
      <div
        *ngIf="!area && hasInteracted['area']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
  </div>

  <div
    style="display: flex; justify-content: center; gap: 10px; margin-top: 10px"
  >
    <!-- Botón Aceptar -->
    <button
      type="button"
      pButton
      label="Guardar cambios"
      [disabled]="isDisabled"
      (click)="onEdit()"
      class="btn"
    ></button>
  </div>
</p-dialog>
